<template>
    <div style="text-align:left">
        <Breadcrumb style="margin: 0px 10px 20px">
            <BreadcrumbItem to="/userAdmin">用户管理</BreadcrumbItem>
            <BreadcrumbItem>个人设置</BreadcrumbItem>
        </Breadcrumb>
        <Card>
            <!-- <h3>个人设置</h3> -->
            <Row type="flex" class="row">
                <!-- <Upload style="width: 100px; height: 100px;margin-left:20px"
                    :before-upload="handleUpload"
                    accept="image/jpg, image/jpeg, image/png, image/gif"
                    :on-format-error="handleFormatError"
                    :max-size="2048"
                    type="drag"
                    action=""> -->
                    <div style="position: relative;padding:5px 0;width: 100px;height: 100px;margin-left:20px;border:1px dotted;">
                        <!-- <Icon type="ios-camera" size="30" style="color: #3BBE9B;margin-top:30px"></Icon> -->
                        <img :src="formItem.avatar" style="width:100%;position:absolute;top:0;left:0;right:0; bottom:0; margin:auto;" v-if="formItem.avatar"/>
                        <Spin fix v-show="uploading"></Spin>
                    </div>
                <!-- </Upload> -->
            </Row>
            <Row type="flex" class="row">
                <Col span="6" class="col1" >企业微信id</Col>
                <Col span="12">{{open_id}}</Col>
            </Row>
            <Row type="flex" class="row">
                <Col span="6" class="col1" >用户名</Col>
                <Col span="12">{{name}}</Col>
            </Row>
            <Row type="flex" class="row">
                <Col span="6" class="col1" >邮箱</Col>
                <Col span="12">{{email}}</Col>
            </Row>
            <Row type="flex" class="row">
                <Col span="6" class="col1" >用户权限</Col>
                <Col span="12" v-if="role_type==0">禁止访问</Col>
                <Col span="12" v-if="role_type==1">管理员</Col>
                <Col span="12" v-if="role_type==2">普通用户</Col>
                <Col span="12" v-if="role_type==3">高级用户</Col>
            </Row>
            <Row type="flex" class="row">
                <Col span="6" class="col1" >登录时间</Col>
                <Col span="12">{{login_at}}</Col>
            </Row>
            <Row type="flex" class="row">
                <Col span="6" class="col1" >退出时间</Col>
                <Col span="12">{{logout_at}}</Col>
            </Row>
            <Row type="flex" class="row">
                <!-- <Button style="margin-right:30px">修改基本信息</Button> -->
                <Button style="margin-left:20px" @click="handleChangePassword()">修改密码</Button>
            </Row>
        </Card>
    </div>
</template>
<script>
import{getUserDetail,changePassword,logout}from "@/request/api"
import Cookies from 'js-cookie';
export default {
    name: 'userinfo',
    meta:{},
    data() {
        return {
            formItem:{
                avatar: ''
            },
            email: "",
            login_at: "",
            logout_at: "",
            name: "",
            open_id: "",
            role_type: 0,
            uploading:false,
            new_password: ''
        };
    },
    methods: {
        handleChangePassword () {
            this.$Modal.confirm({
                closable: true,
                title: '修改密码',
                width: 300,
                render: (h) => {
                    return h('Input', {
                        props:{
                            value: this.new_password,
                        },
                        on: {
                            input: (val) => {
                                this.new_password = val;
                            }
                        }
                    }
                    );
                },
                onOk: () => {
                    changePassword(
                        {
                            password: this.new_password
                        }
                    ).then(({ data: res }) => {
                        console.log(res);
                        if(res.code == 200){
                            this.handleLogout()
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })
                },
                onCancel: () => {
                }
            })
        },
        getData(){
            getUserDetail({}).then(res=>{
                if(res.data.code==200){
                    this.name=res.data.data.name
                    this.email=res.data.data.email
                    this.open_id=res.data.data.open_id
                    this.role_type=res.data.data.role_type
                    this.login_at=res.data.data.login_at
                    this.logout_at=res.data.data.logout_at
                    this.formItem.avatar=res.data.data.avatar
                }
            })
        },
        handleUpload(){},
        handleFormatError(){},
        handleLogout(){
            logout().then(({ data: res }) => {
                if(res.code == 200){
                    Cookies.remove("token")
                    Cookies.remove("userInfo")
                    this.$router.push({
                        name: "login"
                    });
                }
            })
        },
    },
    created() {
        Cookies.set('active_name', '5');
        this.getData()
    },
};
</script>
<style scoped>
.row{
  margin: 20px;
  max-width:500px
}
.col1{
    color: rgba(71,86,99,.8);
    padding: 0 16px;
    text-indent: 0.7em;
    margin-right: 30px;
    white-space: nowrap;
    text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/views/User/UserInfo.vue